// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purchase_container__v3dSP {
  width: 100%;
  height: 100%;
  border: 1px solid var(--sb-border-color);
  border-top: none;
  padding: 18px 24px 0 26px;
}
.purchase_container__v3dSP .purchase_selectPlan__Vb9do {
  width: 100%;
  background-color: var(--re-select-dark-bg);
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 11px 20px 10px 16px;
  margin-top: 17px;
}
@media (max-width: 1850px) {
  .purchase_container__v3dSP {
    padding: 11px 10px 0 10px;
  }
}
@media (max-width: 781px) {
  .purchase_container__v3dSP {
    padding: 11px 14px 0 14px;
  }
}
.purchase_container__v3dSP .purchase_brand__xwgYM {
  display: flex;
}
.purchase_container__v3dSP .purchase_brand__xwgYM svg {
  width: 36px;
  height: 36px;
}
.purchase_container__v3dSP .purchase_brand__xwgYM span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
  margin-left: 6px;
}
@media (max-width: 781px) {
  .purchase_container__v3dSP .purchase_brand__xwgYM span {
    font-size: 16px;
  }
}
.purchase_container__v3dSP select {
  margin-top: 10px;
}
@media (max-width: 781px) {
  .purchase_container__v3dSP select {
    height: 42px;
  }
}
.purchase_container__v3dSP .purchase_lab__UIlaR {
  width: 100%;
  height: 320px;
  max-height: 320px;
  min-height: 320px;
  border: 1px solid var(--re-border-color);
  border-radius: 12px;
  padding: 20px 20px 23px 20px;
  position: relative;
  margin-top: 13px;
}
@media screen and (max-width: 1600px) {
  .purchase_container__v3dSP .purchase_lab__UIlaR {
    padding: 20px 10px 23px 10px;
  }
}
@media screen and (max-width: 781px) {
  .purchase_container__v3dSP .purchase_lab__UIlaR {
    padding: 16px 20px 23px 20px;
    height: 270px;
  }
}
.purchase_container__v3dSP .purchase_lab__UIlaR span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 781px) {
  .purchase_container__v3dSP .purchase_lab__UIlaR span {
    font-size: 24px;
  }
}
.purchase_container__v3dSP .purchase_lab__UIlaR .purchase_labList__Y\\+nCM {
  width: 100%;
  height: 160px;
  max-height: 160px;
  min-height: 160px;
  margin-top: 16px;
  overflow-y: hidden;
  overflow-x: hidden;
}
@media screen and (max-width: 781px) {
  .purchase_container__v3dSP .purchase_lab__UIlaR .purchase_labList__Y\\+nCM {
    margin-top: 8px;
  }
}
.purchase_container__v3dSP .purchase_lab__UIlaR .purchase_labList__Y\\+nCM .purchase_labItem__\\+5YuT {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.purchase_container__v3dSP .purchase_lab__UIlaR .purchase_labList__Y\\+nCM .purchase_labItem__\\+5YuT .purchase_moreItemText__\\+v3D4 {
  margin-left: 7px;
}
.purchase_container__v3dSP .purchase_lab__UIlaR .purchase_labList__Y\\+nCM::-webkit-scrollbar,
.purchase_container__v3dSP .purchase_lab__UIlaR ::-webkit-scrollbar-thumb,
.purchase_container__v3dSP .purchase_lab__UIlaR ::-webkit-scrollbar-track {
  background-color: var(--bg-color);
}
.purchase_container__v3dSP .purchase_lab__UIlaR .purchase_from__jHsoo {
  color: var(--re-from-color);
  font-family: Red Hat Display;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 15px;
}
.purchase_container__v3dSP .purchase_lab__UIlaR .purchase_labInfo__wpbnm {
  min-width: 100%;
  max-width: 100%;
  display: flex;
  margin-top: 2px;
}
.purchase_container__v3dSP .purchase_lab__UIlaR .purchase_labInfo__wpbnm span {
  margin-right: auto;
}
.purchase_container__v3dSP .purchase_lab__UIlaR .purchase_labInfo__wpbnm button {
  line-height: 16px;
}
.purchase_container__v3dSP .purchase_lab__UIlaR .purchase_labInfo__wpbnm button svg {
  top: 36%;
}
.purchase_container__v3dSP .purchase_lab__UIlaR .purchase_logo__TeSeP {
  width: 38px;
  height: 38px;
  position: absolute;
  top: 17px;
  right: 24px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa {
  width: 100%;
  height: 310px;
  background-color: var(--sb-bg-color);
  border-radius: 12px;
  margin-top: 16px;
  padding: 11px 20px 20px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_title__NsoRs {
  display: flex;
}
@media screen and (max-width: 781px) {
  .purchase_container__v3dSP .purchase_amount__jkDNa .purchase_title__NsoRs svg {
    width: 32px;
    height: 32px;
  }
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_title__NsoRs span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px;
  margin-left: 6px;
}
@media screen and (max-width: 781px) {
  .purchase_container__v3dSP .purchase_amount__jkDNa .purchase_title__NsoRs span {
    font-size: 18px;
    line-height: 30px;
  }
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_buttonClicked__GJHtx {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  font-size: 12px;
  background: linear-gradient(160.35deg, #FFA329 13.16%, #FE7B1C 42.24%, #FC2A01 71.32%);
  border: 1px solid #777778;
  border-radius: 15px;
  margin-right: 60px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_buttonNotClicked__AzSqX {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  background: var(--sb-bg-color);
  box-sizing: border-box;
  border: 1px solid #777778;
  border-radius: 10px;
  margin-right: 60px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_paymentMethod__Idk2B span {
  width: 36px;
  height: 18px;
  font-weight: 700;
  font-family: Red Hat Display;
  font-size: 12px;
  color: var(--font-color);
  margin-left: 25px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_paymentLabel__E9zmY {
  display: flex;
  margin-top: 13px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_paymentLabel__E9zmY span {
  color: var(--re-from-color);
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_dataLabel__xp62W {
  display: flex;
  margin-top: 15px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_dataLabel__xp62W span {
  color: var(--re-from-color);
  text-align: right;
  font-family: Red Hat Display;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_dataLabel__xp62W span:first-child {
  margin-left: 9px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_dataLabel__xp62W span:last-child {
  margin-left: auto;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_price__SuiFJ {
  display: flex;
  margin-top: 3px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_price__SuiFJ span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_price__SuiFJ span:first-child {
  margin-left: 9px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_price__SuiFJ span:last-child {
  margin-left: auto;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_button__Wuq9J {
  width: 100%;
  display: flex;
  margin-top: 14px;
}
@media screen and (max-width: 781px) {
  .purchase_container__v3dSP .purchase_amount__jkDNa .purchase_button__Wuq9J button {
    height: 38px !important;
  }
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_button__Wuq9J button:last-child {
  margin-left: 11px;
}
.purchase_container__v3dSP .purchase_amount__jkDNa .purchase_button__Wuq9J img {
  top: 22%;
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/purchase/purchase.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;EACA,yBAAA;AACJ;AACI;EACI,WAAA;EACA,0CAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AACR;AAEI;EAtBJ;IAuBQ,yBAAA;EACN;AACF;AACI;EA1BJ;IA2BQ,yBAAA;EAEN;AACF;AAAI;EACI,aAAA;AAER;AAAQ;EACI,WAAA;EACA,YAAA;AAEZ;AACQ;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AACZ;AACY;EATJ;IAUQ,eAAA;EAEd;AACF;AAEI;EACI,gBAAA;AAAR;AAEQ;EAHJ;IAIQ,YAAA;EACV;AACF;AAEI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,wCAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AAAR;AAEQ;EAXJ;IAYQ,4BAAA;EACV;AACF;AACQ;EAfJ;IAgBQ,4BAAA;IACA,aAAA;EAEV;AACF;AAAQ;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEZ;AAAY;EARJ;IASQ,eAAA;EAGd;AACF;AAAQ;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAEZ;AAAY;EATJ;IAUQ,eAAA;EAGd;AACF;AADY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAGhB;AADgB;EACI,gBAAA;AAGpB;AAEQ;;;EAGI,iCAAA;AAAZ;AAGQ;EACI,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AADZ;AAIQ;EACI,eAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AAFZ;AAIY;EACI,kBAAA;AAFhB;AAKY;EACI,iBAAA;AAHhB;AAKgB;EACI,QAAA;AAHpB;AAQQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AANZ;AAUI;EACI,WAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AARR;AAUQ;EACI,aAAA;AARZ;AAUY;EACI;IACI,WAAA;IACA,YAAA;EARlB;AACF;AAWY;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAThB;AAWgB;EATJ;IAUQ,eAAA;IACA,iBAAA;EARlB;AACF;AAYQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sFAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAVZ;AAcQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAZZ;AAiBY;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;AAfhB;AAoBQ;EACI,aAAA;EACA,gBAAA;AAlBZ;AAoBY;EACI,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlBhB;AAwBQ;EACI,aAAA;EACA,gBAAA;AAtBZ;AAwBY;EACI,2BAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtBhB;AAyBY;EACI,gBAAA;AAvBhB;AA0BY;EACI,iBAAA;AAxBhB;AA4BQ;EACI,aAAA;EACA,eAAA;AA1BZ;AA4BY;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA1BhB;AA6BY;EACI,gBAAA;AA3BhB;AA8BY;EACI,iBAAA;AA5BhB;AAgCQ;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AA9BZ;AAgCY;EACI;IACI,uBAAA;EA9BlB;AACF;AAiCY;EACI,iBAAA;AA/BhB;AAkCY;EACI,QAAA;AAhChB","sourcesContent":[".container {\n    width: 100%;\n    height: 100%;\n    border: 1px solid var(--sb-border-color);\n    border-top: none;\n    padding: 18px 24px 0 26px;\n\n    .selectPlan {\n        width: 100%;\n        background-color: var(--re-select-dark-bg);\n        border-radius: 12px;\n        border: 1px solid transparent;\n        color: var(--font-dark-color);\n        font-family: Red Hat Display;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        padding: 11px 20px 10px 16px;\n        margin-top: 17px;\n    }\n\n    @media (max-width: 1850px) {\n        padding: 11px 10px 0 10px;\n    }\n\n    @media (max-width: 781px) {\n        padding: 11px 14px 0 14px;\n    }\n\n    .brand {\n        display: flex;\n\n        svg {\n            width: 36px;\n            height: 36px;\n        }\n\n        span {\n            color: var(--font-color);\n            font-family: Red Hat Display;\n            font-size: 20px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 38px;\n            margin-left: 6px;\n\n            @media (max-width: 781px) {\n                font-size: 16px;\n            }\n        }\n    }\n\n    select {\n        margin-top: 10px;\n\n        @media (max-width: 781px) {\n            height: 42px;\n        }\n    }\n\n    .lab {\n        width: 100%;\n        height: 320px;\n        max-height: 320px;\n        min-height: 320px;\n        border: 1px solid var(--re-border-color);\n        border-radius: 12px;\n        padding: 20px 20px 23px 20px;\n        position: relative;\n        margin-top: 13px;\n\n        @media screen and (max-width: 1600px) {\n            padding: 20px 10px 23px 10px;\n        }\n\n        @media screen and (max-width: 781px) {\n            padding: 16px 20px 23px 20px;\n            height: 270px;\n        }\n\n        span {\n            color: var(--font-color);\n            font-family: Red Hat Display;\n            font-size: 24px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: normal;\n\n            @media screen and (max-width: 781px) {\n                font-size: 24px;\n            }\n        }\n\n        .labList {\n            width: 100%;\n            height: 160px;\n            max-height: 160px;\n            min-height: 160px;\n            margin-top: 16px;\n            overflow-y: hidden;\n            overflow-x: hidden;\n\n            @media screen and (max-width: 781px) {\n                margin-top: 8px;\n            }\n\n            .labItem {\n                display: flex;\n                align-items: flex-start;\n                margin-bottom: 12px;\n\n                .moreItemText {\n                    margin-left: 7px;\n                }\n            }\n        }\n\n        .labList::-webkit-scrollbar,\n        ::-webkit-scrollbar-thumb,\n        ::-webkit-scrollbar-track {\n            background-color: var(--bg-color);\n        }\n\n        .from {\n            color: var(--re-from-color);\n            font-family: Red Hat Display;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n            margin-top: 15px;\n        }\n\n        .labInfo {\n            min-width: 100%;\n            max-width: 100%;\n            display: flex;\n            margin-top: 2px;\n\n            span {\n                margin-right: auto;\n            }\n\n            button {\n                line-height: 16px;\n\n                svg {\n                    top: 36%;\n                }\n            }\n        }\n\n        .logo {\n            width: 38px;\n            height: 38px;\n            position: absolute;\n            top: 17px;\n            right: 24px;\n        }\n    }\n\n    .amount {\n        width: 100%;\n        height: 310px;\n        background-color: var(--sb-bg-color);\n        border-radius: 12px;\n        margin-top: 16px;\n        padding: 11px 20px 20px;\n\n        .title {\n            display: flex;\n\n            @media screen and (max-width: 781px) {\n                svg {\n                    width: 32px;\n                    height: 32px;\n                }\n            }\n\n            span {\n                color: var(--font-color);\n                font-family: Red Hat Display;\n                font-size: 20px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: 39px;\n                margin-left: 6px;\n\n                @media screen and (max-width: 781px) {\n                    font-size: 18px;\n                    line-height: 30px;\n                }\n            }\n        }\n\n        .buttonClicked {\n            width: 20px;\n            height: 20px;\n            margin-top: 10px;\n            font-size: 12px;\n            background: linear-gradient(160.35deg, #FFA329 13.16%, #FE7B1C 42.24%, #FC2A01 71.32%);\n            border: 1px solid #777778;\n            border-radius: 15px;\n            margin-right: 60px;\n\n        }\n\n        .buttonNotClicked {\n            width: 20px;\n            height: 20px;\n            margin-top: 10px;\n            background: var(--sb-bg-color);\n            box-sizing: border-box;\n            border: 1px solid #777778;\n            border-radius: 10px;\n            margin-right: 60px;\n        }\n\n        .paymentMethod {\n\n            span {\n                width: 36px;\n                height: 18px;\n                font-weight: 700;\n                font-family: Red Hat Display;\n                font-size: 12px;\n                color: var(--font-color);\n                margin-left: 25px;\n            }\n\n        }\n\n        .paymentLabel {\n            display: flex;\n            margin-top: 13px;\n\n            span {\n                color: var(--re-from-color);\n                font-family: Red Hat Display;\n                font-size: 15px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: normal;\n\n            }\n\n        }\n\n        .dataLabel {\n            display: flex;\n            margin-top: 15px;\n\n            span {\n                color: var(--re-from-color);\n                text-align: right;\n                font-family: Red Hat Display;\n                font-size: 13px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: normal;\n            }\n\n            span:first-child {\n                margin-left: 9px;\n            }\n\n            span:last-child {\n                margin-left: auto;\n            }\n        }\n\n        .price {\n            display: flex;\n            margin-top: 3px;\n\n            span {\n                color: var(--font-color);\n                font-family: Red Hat Display;\n                font-size: 24px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n            }\n\n            span:first-child {\n                margin-left: 9px;\n            }\n\n            span:last-child {\n                margin-left: auto;\n            }\n        }\n\n        .button {\n            width: 100%;\n            display: flex;\n            margin-top: 14px;\n\n            @media screen and (max-width: 781px) {\n                button {\n                    height: 38px !important;\n                }\n            }\n\n            button:last-child {\n                margin-left: 11px;\n            }\n\n            img {\n                top: 22%;\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `purchase_container__v3dSP`,
	"selectPlan": `purchase_selectPlan__Vb9do`,
	"brand": `purchase_brand__xwgYM`,
	"lab": `purchase_lab__UIlaR`,
	"labList": `purchase_labList__Y+nCM`,
	"labItem": `purchase_labItem__+5YuT`,
	"moreItemText": `purchase_moreItemText__+v3D4`,
	"from": `purchase_from__jHsoo`,
	"labInfo": `purchase_labInfo__wpbnm`,
	"logo": `purchase_logo__TeSeP`,
	"amount": `purchase_amount__jkDNa`,
	"title": `purchase_title__NsoRs`,
	"buttonClicked": `purchase_buttonClicked__GJHtx`,
	"buttonNotClicked": `purchase_buttonNotClicked__AzSqX`,
	"paymentMethod": `purchase_paymentMethod__Idk2B`,
	"paymentLabel": `purchase_paymentLabel__E9zmY`,
	"dataLabel": `purchase_dataLabel__xp62W`,
	"price": `purchase_price__SuiFJ`,
	"button": `purchase_button__Wuq9J`
};
export default ___CSS_LOADER_EXPORT___;
